import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { apiConnector } from '@/api/api.connector';
import { TOKEN_REFRESH_INTERVAL } from '@/shared/constants';
import { getClientToken } from '@/shared/services/user-hash';
import { setIsAuth } from '@/store/auth.slice';
import { useAppDispatch, useAppSelector } from '@/store/store';

export const useAuthInit = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { isUserAuth } = useAppSelector((state) => state.auth);

  useEffect(() => {
    const { accessToken } = getClientToken();

    if (accessToken) {
      dispatch(setIsAuth(true));
    }

    const refreshInterval = setInterval(async () => {
      try {
        await apiConnector.refreshToken();
      } catch (error) {
        console.error('Не удалось обновить токен:', error);
      }
    }, TOKEN_REFRESH_INTERVAL);

    return () => {
      clearInterval(refreshInterval);
    };
  }, [dispatch]);

  useEffect(() => {
    const { accessToken } = getClientToken();

    if (!accessToken && isUserAuth) {
      dispatch(setIsAuth(false));
    }
  }, [location.pathname, isUserAuth, dispatch]);
};
